// src/components/HeroSection.js
import React from "react";
import "../../styles/HeroSection.css";

const HeroSection = () => {
  const heroStyle = {
    backgroundImage: `url(/assets/img/abc.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center left",
  };

  return (
    <section id="hero" className="hero-section" style={heroStyle}>
      <div className="hero-section__container">
        <div className="hero-section__wrapper">
          <div className="hero-section__content" data-aos="fade-up">
            <div className="title_heading">
              <h1 className="glitch" data-text="Originality">
                Originality
              </h1>
              <h2>Clothing Company</h2>
            </div>
            <h1 className="hero-section__title">
              The Finest Screen Printing For Your Soul
            </h1>
            <p className="hero-section__text" data-aos-delay="100">
              Kami menyediakan solusi produksi garment dan sablon skala nasional
              hingga internasional dengan kualitas premium.
            </p>
            <div className="hero-section__actions" data-aos-delay="200">
              <a
                href="https://wa.me/6281272800800"
                target="_blank"
                rel="noopener noreferrer"
                className="hero-section__btn"
              >
                Contact Us
              </a>
              <a
                href="https://www.youtube.com/watch?v=QkCmjlbhXLg"
                className="hero-section__video glightbox"
                data-type="video"
                data-source="youtube"
              >
                <i className="bi bi-play-circle"></i>
                <span>Watch Video</span>
              </a>
            </div>
          </div>

          <div className="hero-section__image" data-aos="zoom-out">
            <img src="/assets/img/hero-img.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
